import request from '@/utils/request'

export const addLeave = (data) => {
  return request({
    url: '/leave/insert',
    method: 'POST',
    params: data
  })
}

export const searchLeaveByPage = (data) => {
  return request({
    url: '/leave/searchLeaveByPage',
    method: 'POST',
    params: data
  })
}
